var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wallet-solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.984,
    height: 18.99,
    viewBox: "0 0 20.984 18.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M23.306,10.782H21.99V7.391a.678.678,0,0,0-.678-.678H5.035a.678.678,0,0,1,0-1.356H21.04A.678.678,0,1,0,21.04,4H5.035A1.994,1.994,0,0,0,3,5.953V20.2A2.8,2.8,0,0,0,5.815,22.99h15.5a.678.678,0,0,0,.678-.678V18.921h1.316a.631.631,0,0,0,.678-.617V11.521A.732.732,0,0,0,23.306,10.782Zm-.638,6.782H16.849a2.625,2.625,0,0,1-2.53-2.713,2.625,2.625,0,0,1,2.53-2.713h5.819Z",
    transform: "translate(-3 -3.999)",
    fill: "#443107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M24.575,19.437a1.017,1.017,0,1,1-1.017-1.017,1.017,1.017,0,0,1,1.017,1.017Z",
    transform: "translate(-9.288 -8.64)",
    fill: "#443107"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSolid);
export default __webpack_public_path__ + "static/media/wallet-solid.6da3632c7f7a5a9300f26c0f1af31f92.svg";
export { ForwardRef as ReactComponent };